import { useEffect } from "react";
import LandingFooter from "../../components/Landing/Footer/footer";
import Header from "../../components/Landing/Header/header";
import Footer from "../../components/Onboarding/Footer/footer";
import classes from "./awaAI.module.css";
import { YellowButton } from "../../components/UI/Button/button";
import { useNavigate } from "react-router";
import {
  AI_FEATURES,
  AI_HOW_IT_WORKS,
  AI_INSIGHTS,
  AI_WHO_IS_THIS_FOR,
} from "../../constants";
import img1 from "../../assets/images/AwaAI/hero-img.png";
import { ArrowFullIcon, FeatureIcon } from "../../constants/svg";
const AwaAIPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <section className={classes.heroContainer}>
        <div className={classes.container}>
          <div className={classes.content}>
            <h1>
              <span> Meet AWA-AI - </span> Your AI Career Insight Engine
            </h1>
            <p className={classes.subtitle}>
              Discover what AI sees in you before any employer does.
            </p>
            <p className={classes.description}>
              Awa-AI gives you the confidence you need in the job market by
              giving necessary insights about you that employers can trust.
            </p>

            <YellowButton onClick={() => navigate("/login")}>
              Take The Free AI Insight Test
            </YellowButton>
          </div>

          <div className={classes.imageContainer}>
            <img src={img1} alt="Awasource AI Illustration" />
            <div className={classes.insightsMain}>
              {AI_INSIGHTS.map((insight, idx) => (
                <div className={classes.insightsRow} key={idx}>
                  <div className={classes.insight}>
                    <div
                      className={classes.length}
                      style={{
                        width: `${insight.level}%`,
                      }}
                    ></div>
                  </div>
                  <p>{insight.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className={classes.featuresSection}>
        <h2>What is AWA-AI?</h2>
        <p>
          Awa-AI is your best source for unfiltered insights into your career
          habits. It gives you an idea of your work skills based on well
          informed and calculated data. This data is collected via a series of
          questions, then Awa-AI puts this information together in a very simple
          and easy to understand graph.
        </p>
        <div className={classes.features}>
          {AI_FEATURES.map((feature, idx) => (
            <div className={classes.feature} key={idx}>
              <img src={feature.image} alt="AI Feature Illustration" />
              <p>{feature.name}</p>
            </div>
          ))}
        </div>
        <p>Awa-AI reads how you think, not what you claim</p>
      </section>

      <section className={classes.testSection}>
        <h2>What You Get After the Test</h2>
        <div className={classes.testFeaturesMain}>
          <div className={classes.testFeatures}>
            <div className={classes.testFeature}>
              <FeatureIcon />
              <p>Personality & work-style summary</p>
            </div>
            <div className={classes.testFeature}>
              <FeatureIcon />
              <p>Strongest professional traits</p>
            </div>
            <div className={classes.testFeature}>
              <FeatureIcon />
              <p>Areas to improve</p>
            </div>
          </div>
          <div className={classes.line}></div>
          <div className={classes.testFeaturesTwo}>
            <div className={classes.testFeature}>
              <FeatureIcon />
              <p>Roles you are naturally suited for</p>
            </div>
            <div className={classes.testFeature}>
              <FeatureIcon />
              <p>Downloadable AI Insight Profile</p>
            </div>
            <div className={classes.testFeature}>
              <FeatureIcon />
              <p>100% Free (for a limited time)</p>
            </div>
          </div>
        </div>
      </section>

      <section className={classes.sectionFour}>
        <h2>Most People Apply For Jobs Without Knowing Themselves</h2>

        <div className={classes.sectionFourContent}>
          <p> <span></span> Why some roles frustrate you </p>
          <p> <span></span>Why interviews feel hard</p>
          <p> <span></span>Why you feel misunderstood at work</p>
          <p> <span></span>Why you’re unsure what fits you</p>
        </div>
      </section>

      <section className={classes.sectionFive}>
        <h2>How It Works</h2>

        <div className={classes.hiwGroup}>
          {AI_HOW_IT_WORKS.map((item, idx) => (
            <>
              <div className={classes.hiwItem} key={idx}>
                <img src={item.image} alt="AI Feature Illustration" />
                <p>{item.name}</p>
              </div>
              <ArrowFullIcon />
            </>
          ))}
        </div>
      </section>

      <div className={classes.lineFull}></div>

      <section className={classes.sectionSix}>
        <h2>Who Is This For?</h2>

        <div className={classes.hiwGroup}>
          {AI_WHO_IS_THIS_FOR.map((item, idx) => (
            <div className={classes.hiwItem} key={idx}>
              <img src={item.image} alt="AI Feature Illustration" />
              <p>{item.name}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={classes.ctaSection}>
        <h2>Before your next job application, understand yourself first.</h2>
        <YellowButton onClick={() => navigate("/login")}>
          Start Free AI Insight Test
        </YellowButton>
        <p>Powered by Awasource</p>
      </section>

      <footer>
        <p>
          Awa-AI is part of Awasource’s mission to help talents understand
          themselves and connect with the right opportunities.
        </p>
      </footer>
    </>
  );
};

export default AwaAIPage;
